import { render, staticRenderFns } from "./SelectedPlanet.vue?vue&type=template&id=4182385d&scoped=true&"
import script from "./SelectedPlanet.vue?vue&type=script&lang=js&"
export * from "./SelectedPlanet.vue?vue&type=script&lang=js&"
import style0 from "./SelectedPlanet.vue?vue&type=style&index=0&id=4182385d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4182385d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCard,VCardActions,VList,VListItem,VMenu,VSpacer,VSubheader})
